import { render, staticRenderFns } from "./Tr.vue?vue&type=template&id=22866584&scoped=true&"
import script from "./Tr.vue?vue&type=script&lang=js&"
export * from "./Tr.vue?vue&type=script&lang=js&"
import style0 from "./Tr.vue?vue&type=style&index=0&id=22866584&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22866584",
  null
  
)

export default component.exports